import { ApiError } from "../../api/apiError";

const HTTP_CONFLICT = 409;
const NO_RUNNER = "no_runner";

/**
 * Распознаёт отказ «у организации нет раннера» мутирующей ручки
 * очереди (`POST /tasks`, `POST /queue/*`).
 *
 * Backend отвечает на это состояние `409` с кодом `no_runner`:
 * различение идёт по паре статус + `code`, прочие `409` (другой код
 * или тело без кода) сюда не относятся. Отсутствие раннера на ЧТЕНИИ
 * (`GET /api/v1/queue`) определяется не кодом ответа, а значением
 * `queue === null` в теле — ручка всегда отвечает `200`, этот
 * предикат к ней не относится.
 *
 * `null` (ошибки нет) — не признак отсутствия раннера, вызывающему не
 * нужно проверять это отдельно.
 */
export function isNoRunnerConflict(error: Error | null): boolean {
  return (
    error instanceof ApiError &&
    error.status === HTTP_CONFLICT &&
    error.code === NO_RUNNER
  );
}
